module.exports = __webpack_public_path__ + "img/9.53208410.png";